import React, { useState } from "react";

import { LoginForm } from "../comonents/Forms/LoginForm";
import { RegisterForm } from "../comonents/Forms/RegesterForm";
import { Footer } from "../comonents/Footer/Footer";

import styles from "../comonents/Forms/LoginForm.module.css";
import { PasswordResetRequest } from "../comonents/Forms/PasswordResetRequest";


export const Login = (props) => {

    // props:
    //
    // putToken - function to save token to local storage

    // ----------------------------------------------------- STATE AND HOOKS

    const [isLoggingIn, setIsLoggingIn] = useState(true);
    const [isResettingPassword, setIsResettingPassword] = useState(false);

    // ----------------------------------------------------- PRE-RENDER

    // ----------------------------------------------------- RENDER

    if (isResettingPassword) {
        return (
            <section className={styles.container}>
            <div className={styles.content}>
                <img src="/assets/images/cat.png" className={styles.logo} />
                <PasswordResetRequest setIsResettingPassword={setIsResettingPassword}/>
            </div>
            <Footer />
        </section>
        )
    }
    return (
        <section className={styles.container}>
            <div className={styles.content}>
                <img src="/assets/images/logo.png" className={styles.logo} />
                {
                    isLoggingIn ? (
                        <div>
                            <LoginForm putToken={props.putToken} setIsResettingPassword={setIsResettingPassword}/>
                            <div className={styles.noAccount}>
                                <span>Don't have an account?</span>
                                <span><button className={styles.registerButton} onClick={() => { setIsLoggingIn(false) }}>Register!</button></span>
                            </div>
                        </div>
                    ) : (
                        <div >
                            <RegisterForm putToken={props.putToken} />
                            <div className={styles.noAccount}>
                                <span>Already have an account?</span>
                                <span><button className={styles.registerButton} onClick={() => { setIsLoggingIn(true) }}>Sign in!</button></span>
                            </div>
                        </div>

                    )
                }
            </div>
            <Footer />
        </section>
    );
}